import { Paper, Stack } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import React from "react";
import useDebugInformation from "../../../hooks/useDebugInformation";
import { state, ui } from '../../../interfaces/interfaces';
import { useAppSelector } from "@store/hooks";
import ButtonIcon from "./ButtonIcon";

const name = "ToggleButtonsGroup";

type Props = {
    values: string[]
    groupName: "StepTwoActiveTab" | "StepThreeActiveTab"
    step: number
}

const handleChange = (event: React.MouseEvent<HTMLElement, MouseEvent>, value: string, groupName: Props["groupName"]) => {
    // const value = event.currentTarget.value
    value && (ui[groupName] = value as never)
    value === "address" && groupName === "StepTwoActiveTab" && (state.Step2_3Clicked = true)
};

const ToggleButtonsGroup: React.FC<Props> = ({ values, groupName, step }) => {
    const activeTab = useAppSelector(({ ui }) => ui[groupName])
    // CHANGE HANDLING
    const memoProp = React.useMemo(() => ({ values, groupName }), [groupName, values])
    const debugName = `${name}${memoProp.groupName}`;

    useDebugInformation(debugName, { memoProp, activeTab })
    return (
        <Stack justifyContent="center" direction="row" sx={{ pb: 1 }}>
            <Paper elevation={2} >
                <ToggleButtonGroup size="small" value={activeTab} exclusive onChange={React.useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>, v: any) => handleChange(e, v, memoProp.groupName), [memoProp.groupName])}>
                    {memoProp.values.map((value, idx) =>
                        <ToggleButton key={idx + 1} value={value} >
                            <ButtonIcon index={idx + 1} step={step} parent={debugName} />
                            {value.toUpperCase()}
                        </ToggleButton>)}
                </ToggleButtonGroup>
            </Paper>
        </Stack>);
}

ToggleButtonsGroup.displayName = name;


export default React.memo(ToggleButtonsGroup)